<template>
  <dl class="innews_list">
    <dd v-for="(item,index) in title.arts" :key="index">
      <i>&nbsp;</i><router-link :to="'/home/article/'+title.id+'/'+item.id">{{item.name}}</router-link>
      <span>{{item.update_time.slice(0,10)}}</span>
    </dd>
  </dl>
</template>

<script>
export default {
  props: {
    title: {
      type: Object,
      default: {}
    }
  }
};
</script>

<style scoped>
.innews_list {
  min-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/newsList.vue